/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rn_howto_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How to use it`)
};

const es_rn_howto_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo usarlo`)
};

const de_rn_howto_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`So wird es verwendet`)
};

const nl_rn_howto_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe het te gebruiken`)
};

const fr_rn_howto_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment l'utiliser`)
};

const it_rn_howto_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come usarlo`)
};

const pt_br2_rn_howto_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como usar`)
};

const pt_rn_howto_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como usar`)
};

const ja_rn_howto_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使い方`)
};

const zh_rn_howto_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用方法`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rn_howto_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rn_howto_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rn_howto_title", locale)
	if (locale === "en") return en_rn_howto_title(inputs)
	if (locale === "es") return es_rn_howto_title(inputs)
	if (locale === "de") return de_rn_howto_title(inputs)
	if (locale === "nl") return nl_rn_howto_title(inputs)
	if (locale === "fr") return fr_rn_howto_title(inputs)
	if (locale === "it") return it_rn_howto_title(inputs)
	if (locale === "pt-BR") return pt_br2_rn_howto_title(inputs)
	if (locale === "pt") return pt_rn_howto_title(inputs)
	if (locale === "ja") return ja_rn_howto_title(inputs)
	return zh_rn_howto_title(inputs)
};